(() => {
  'use strict';
  if (customElements.get('sq-auto-carousel')) return;
  customElements.define('sq-auto-carousel', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const track = this.querySelector('[data-carousel-track]');
      const button = this.querySelector('[data-carousel-pause]');
      const nextButton = this.querySelector('[data-carousel-next]');
      if (!track || !button) return;
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let paused = reduced.matches, hovering = false, focused = false, visible = false;
      const listen = (target, type, action, options = {}) => target.addEventListener(type, action, {...options, signal:this.controller.signal});
      const update = () => {button.textContent = paused ? 'Play' : 'Pause'; button.setAttribute('aria-label', `${paused ? 'Play' : 'Pause'} carousel`);};
      const size = () => {
        const fits = track.scrollWidth <= track.clientWidth + 2;
        button.hidden = fits;
        if (nextButton) {
          nextButton.hidden = fits;
          const image = track.querySelector('img');
          if (image) this.style.setProperty('--sq-carousel-arrow-y', `${image.getBoundingClientRect().top - this.getBoundingClientRect().top + image.getBoundingClientRect().height / 2}px`);
        }
      };
      const advance = () => {
        const max = track.scrollWidth - track.clientWidth;
        if (max <= 2) return;
        const cards = Array.from(track.children);
        const left = cards[0].getBoundingClientRect().left;
        const stops = cards.map(card => Math.min(max, card.getBoundingClientRect().left - left));
        const next = stops.find(x => x > track.scrollLeft + 3);
        track.scrollTo({left:next === undefined ? 0 : next, behavior:reduced.matches ? 'instant' : 'smooth'});
      };
      listen(button, 'click', () => {paused = !paused; update();});
      listen(track, 'pointerenter', e => {if (e.pointerType === 'mouse') hovering = true;});
      listen(track, 'pointerleave', () => {hovering = false;});
      listen(track, 'focusin', () => {focused = true;});
      listen(track, 'focusout', e => {focused = track.contains(e.relatedTarget);});
      const pause = () => {paused = true; update();};
      if (nextButton) listen(nextButton, 'click', () => {pause(); advance();});
      listen(track, 'load', size, {capture:true});
      listen(track, 'pointerdown', pause);
      listen(track, 'wheel', pause, {passive:true});
      listen(track, 'keydown', pause);
      listen(reduced, 'change', () => {if (reduced.matches) pause();});
      this.observer = new IntersectionObserver(entries => {visible = entries.some(e => e.isIntersecting); size();}, {threshold:0.2});
      this.observer.observe(this);
      this.resize = new ResizeObserver(size);this.resize.observe(track);
      this.timer = setInterval(() => {
        if (paused || hovering || focused || !visible || document.hidden || this.closest('[hidden]')) return;
        advance();
      }, Number(this.dataset.interval) || 4500);
      update();size();
    }
    disconnectedCallback() {clearInterval(this.timer);this.observer?.disconnect();this.resize?.disconnect();this.controller?.abort();this.controller=null;}
  });
})();
